import { useCallback } from 'react';
import { fabric } from 'fabric';
import { ToastVariants } from '@dotcom/crown-ui';
import { useTranslation } from 'react-i18next';
import { useAppContext, setIsToasterOpen } from '../context/app-context';
import { useAnalyticsContext } from '../context/analytics-context';

export const useAddLowResIcon = () => {
  const { trackLowResImageToast } = useAnalyticsContext();
  const { appDispatch } = useAppContext();
  const { t } = useTranslation();

  return useCallback(
    (icon: fabric.Image) => {
      if (!icon.visible) return;
      setIsToasterOpen(appDispatch, {
        title: '',
        children: t('lowResolutionImage.message'),
        variant: ToastVariants.Warning,
      });
      trackLowResImageToast();
    },
    [appDispatch, t, trackLowResImageToast],
  );
};
